import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

const SourcePriorityScreen = lazy(
  () => import('~/features/item-setup/pages/source-priority-screen'),
);

export const Route = createFileRoute('/_authenticated/_tenant/item-setup/source-priority')({
  // Super-admin-only step — non-super-admins are sent back to the output-format step.
  beforeLoad: requireSystemAdmin('/item-setup/output-format'),
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <SourcePriorityScreen />
    </Suspense>
  ),
});
